import './App.css';
import { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import CoachRoutes from './routes/coach/CoachRoutes';
import AdminRoutes from './routes/admin/AdminRoutes';
import FindAJobRoutes from './routes/find-a-job/FindAJobRoutes';
import HireTalentRoutes from './routes/hire-talent/HireTalentRoutes';
import EnterPrisesRoutes from "./routes/enterprises/EnterPrisesRoutes";
import FundingRoutes from './routes/funding/FundingRoutes';

function App() {
  useEffect(() => {
    const OPEN_MODAL_SELECTOR = [
      ".modal.show",
      ".modal.d-block",
      ".ct_signup_modal_overlay",
      ".job-modal-overlay",
      ".asm-overlay",
      ".unlock-profile-overlay",
    ].join(", ");

    const CUSTOM_OVERLAY_SELECTOR = [
      ".ct_signup_modal_overlay",
      ".job-modal-overlay",
      ".asm-overlay",
      ".unlock-profile-overlay",
    ].join(", ");

    const closeModalElement = (element) => {
      if (!element) return;

      if (element.matches(CUSTOM_OVERLAY_SELECTOR)) {
        element.dispatchEvent(new MouseEvent("click", { bubbles: true }));
        return;
      }

      if (element.classList.contains("modal")) {
        const bootstrapModalApi = window?.bootstrap?.Modal;
        if (bootstrapModalApi) {
          const instance = bootstrapModalApi.getInstance(element);
          if (instance) {
            instance.hide();
            return;
          }
        }

        const closeBtn = element.querySelector(
          "[data-bs-dismiss='modal'], .btn-close, .ct_close_position_right12, .ct_circle_close"
        );
        if (closeBtn) {
          closeBtn.click();
          return;
        }

        element.classList.remove("show", "d-block");
        element.setAttribute("aria-hidden", "true");
        element.style.display = "none";
      }
    };

    let rafId = null;
    const enforceSingleModal = () => {
      const openModals = Array.from(document.querySelectorAll(OPEN_MODAL_SELECTOR))
        .filter((el) => {
          const style = window.getComputedStyle(el);
          return style.display !== "none" && style.visibility !== "hidden";
        });

      if (openModals.length <= 1) return;

      const topMost = openModals[openModals.length - 1];
      openModals.forEach((modalEl) => {
        if (modalEl !== topMost) {
          closeModalElement(modalEl);
        }
      });
    };

    const queueEnforce = () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(enforceSingleModal);
    };

    queueEnforce();
    const observer = new MutationObserver(queueEnforce);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style", "aria-hidden"],
    });

    return () => {
      if (rafId) cancelAnimationFrame(rafId);
      observer.disconnect();
    };
  }, []);

  return (
    <div className="App">
      <Toaster position="top-center" reverseOrder={false} />
      <CoachRoutes />
      <AdminRoutes />
      <FindAJobRoutes />
      <HireTalentRoutes />
      <EnterPrisesRoutes />
      <FundingRoutes />
    </div>
  );
}

export default App;
